import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './TipsAndImprovementSidePanel.styles'
import { Typography } from '@mui/material'
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core'

export interface TipsContentData {
  icon?: IconDefinition
  text?: string
  link?: string
}

export interface TipsAndImprovementSidePanelProps {
  content: TipsContentData[]
}

export const TipsAndImprovementSidePanel = React.memo(
  ({ content }: TipsAndImprovementSidePanelProps) => {
    const { classes: styles } = useStyles()
    return (
      <div className={styles.text}>
        <div className={styles.horizontalDivider}></div>
        {content.map((item, index) => (
          <div key={index} className={styles.contentWraper}>
            <FontAwesomeIcon
              icon={item.icon as IconProp}
              style={{ width: '24px', height: '24px', fontSize: '24px' }}
            />
            <div className={styles.textLinkWrapper}>
              <div style={{ width: '600px', display: 'flex', gap: '8px' }}>
                <Typography>{item.text}</Typography>
                {item.link && (
                  <span>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faExternalLink}
                        className={styles.externalLinkIcon}
                      />
                    </a>
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
)
